module.exports = __webpack_public_path__ + "static/media/FREEDOM-CNX-Li-52-iQ.745c93d5.png";